import { revokeSessionBody } from '@planuze/admin-contracts';
import { toast } from '@planuze/ui';
import { useUsersContent } from '../../../content/sections/users.js';
import { useRevokeSession } from '../../../hooks/use-users.js';
import { ReasonDialog } from '../../reason-dialog.js';
import { userErrorMessage } from '../user-error.js';

interface Props {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly userId: string;
  readonly sessionId: string;
}

export function RevokeSessionModal({ open, onClose, userId, sessionId }: Props) {
  const copy = useUsersContent();
  const revoke = useRevokeSession(userId);
  const confirm = (reason: string): void => {
    revoke.mutate(
      { sessionId, reason },
      {
        onSuccess: () => {
          toast.success(copy.revokeSessionModal.success);
          onClose();
        },
        onError: (err) => {
          toast.error(userErrorMessage(err, copy.errors));
        },
      },
    );
  };
  return (
    <ReasonDialog
      open={open}
      onClose={onClose}
      title={copy.revokeSessionModal.title}
      description={copy.revokeSessionModal.description}
      confirmLabel={copy.revokeSessionModal.confirmLabel}
      reasonLabel={copy.revokeSessionModal.reasonLabel}
      destructive
      pending={revoke.isPending}
      validate={(reason) => revokeSessionBody.safeParse({ reason }).success}
      onConfirm={confirm}
    />
  );
}
